import { PropsWithChildren, useState } from 'react';
import { Box } from '@mui/material';
import {
  ProtectedElement,
  WithFallbacks,
} from '#features/auth/components/ProtectedElement';
import { ProtectedIfxElement } from '#features/auth/components/ProtectedIfxElement';
import { GlobalSubscriptionProvider } from './GlobalSubscriptionProvider';
import { ShellContext } from './ShellContext';

export const Shell = (props: PropsWithChildren<WithFallbacks>) => {
  const { alternativeRoute: fallbackTo, children } = props;
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);

  return (
    <ProtectedElement alternativeRoute={fallbackTo}>
      <ProtectedIfxElement>
        <GlobalSubscriptionProvider>
          <ShellContext.Provider value={{ containerRef }}>
            <Box ref={setContainerRef} sx={{ height: '100%' }}>
              {children}
            </Box>
          </ShellContext.Provider>
        </GlobalSubscriptionProvider>
      </ProtectedIfxElement>
    </ProtectedElement>
  );
};
